import { SectionWrapper } from "../../../styles/common";
import App from "@graphic/App";

const Malligyong2D = ({ enteringTime, selectedNoradId, title }) => {
  return (
    <SectionWrapper>
      <div className="title">Peninsula View (2D)</div>
      <div className="content">
        <App
          map="/static/earth-large.jpg"
          bump="/static/bump-large.jpg"
          clouds="/static/clouds-large.jpg"
          time={enteringTime}
          noradId={selectedNoradId}
          satType={title}
          cameraType="ORTHOGRAPHIC"
        />
      </div>
    </SectionWrapper>
  );
};

export default Malligyong2D;
